<template>
  <div class="page-modal">
    <widgetModal v-if="false" title="Select Assignment" subtitle="" btnlefttext="Confirm" btncentertext="Cancel"
      btnrighttext="" :leftloading="false" :rightloading="false" :centerloading="false" :footerhidden="false"
      :loading="internship_loading" footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 40px"
      body_padding="0px 30px" width="700px" :hiderightbtn="true" @onLeftClick="onConfirm()" @onCenterClick="onCancel"
      @onRightClick="onRightClick()">
      <template v-slot:right_header_options>
        <div class="assign-lia-options">
          <widgetButton :loading="false" class="btn-secondary" @click="addNewPrivateLia()">
            Creat a new personal Assignment
          </widgetButton>
        </div>
      </template>
      <div class="widget-modal-body-noscoll">
        <div class="lia-filter-options-widget">
          <div class="row">
            <widgetSearch icon="right" class="lia-search-input" v-model="form_filter.query" @keyup="searchLia()"
              placeholder="Type in to Search…"></widgetSearch>
            <div class="v-line-divider" style="height: 40px"></div>
            <widgetDropdown v-model="show_filter" :right="true" :hover="false" :interactive="true">
              <button class="btn-dropdown">
                <img src="@/assets/admin-icon/filter.svg" class="icon" />
                Filter
                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
              </button>
              <div slot="dropdown" class="dropdown-widget right">
                <a class="dropdown-item" href="#" v-for="(item, index) in view_filter" :key="index" @click="
                  () => {
                    form_filter.filter = item.value;
                    show_filter = false;
                    searchLia();
                  }
                ">
                  {{ item.name }}
                </a>
              </div>
            </widgetDropdown>
          </div>
        </div>
        <div class="lia-list-container">
          <div class="internship-item" v-for="(item, index) in internships" :key="index"
            @click="form.internship_id = item.id">
            <div class="internship-item-header">
              <div class="internship-item-header-left">
                <div class="internship-item-title-widget">
                  <h1 class="internship-item-title">
                    {{ item.name }}
                  </h1>
                  <div v-if="false" class="internship-item-worktype">
                    <span>On Site</span>
                  </div>
                </div>

                <div class="internship-item-location">{{ item.address }}</div>

                <div class="internship-item-date">
                  <span v-if="item.from">{{ item.from | formatDate }} -
                    {{ item.to | formatDate }}</span>
                </div>
              </div>
              <div class="internship-item-header-right">
                <div class="internship-item-selected-widget">
                  {{ item.id == form.internship_id ? "Selected" : "" }}
                  <input class="checkbox" v-model="form.internship_id" type="radio" name="lia" :value="item.id" />
                </div>
              </div>
            </div>

            <div class="internship-item-body">
              <div class="internship-item-tags">
                <template v-for="(tag, index) in item.tags">
                  <widgetTagItem :key="index" :value="tag.name" :canClose="false"></widgetTagItem>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </widgetModal>


  </div>
</template>
<script>
export default {
  name: "page-modal",
  components: {

  },
  props: {
    student: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show_add_new_lia_modal: false,
      show_filter: false,
      view_filter: [
        {
          name: "Recently created",
          value: "recent",
        },
        {
          name: "A-Z",
          value: "a-z",
        },
      ],
      internship_loading: false,
      internships: [],
      form_filter: {
        query: "",
        filter: "",
      },
      form: {
        internship_id: null,
        students: [],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.addNewPrivateLia();
    //vm.getPrivateLia();
  },
  methods: {
    onCloseAddNewLiaModal() {
      let vm = this;
      vm.show_add_new_lia_modal = false;
      vm.$emit("close", null);
    },
    searchLia() {
      let vm = this;
      vm.getPrivateLia();
    },
    addNewPrivateLia() {
      this.show_add_new_lia_modal = true;
    },
    onAddNewLiaSuccess(data) {
      let vm = this;
      vm.show_add_new_lia_modal = false;
      vm.form.internship_id = data.id;
      vm.onConfirm();
    },
    getPrivateLia() {
      let vm = this;
      vm.internship_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_GET_PRIVATE_INTERNSHIP", vm.form_filter)
        .then((responce) => {
          vm.internship_loading = false;
          vm.internships = responce.data.map((item) => {
            let full_location = "";
            //is location array
            if (Array.isArray(item.location)) {
              full_location = item.location.join(", ");
            } else {
              full_location = item.location;
            }
            if (item.location && Array.isArray(item.location)) {
              item.location.forEach((location, index) => {
                full_location += index == 0 ? location : ", " + location;
              });
            } else {
              full_location = item.location;
            }
            return {
              ...item,
              selected: false,
              address: full_location,
            };
          });
          console.log(vm.internships);
        })
        .catch((error) => {
          console.log(error);
          vm.internship_loading = false;
        });
    },
    onConfirm() {
      let vm = this;
      vm.form.students = [vm.student.id];
      const rules = {
        internship_id: {
          run: (value) => {
            if (!value) {
              return "Please select Assignment";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.internship_loading = true;
        vm.$store
          .dispatch("INTERNSHIP_ASSIGN_INTERNSHIP", vm.form)
          .then((responce) => {
            vm.internship_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Assignment assigned successfully",
              type: "success",
              duration: 3000,
            });
            vm.$emit("success", null);
          })
          .catch((error) => {
            vm.internship_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {
  .assign-lia-options {
    padding-right: 30px;
  }

  .widget-modal-body-noscoll {
    height: 500px;
    display: flex;
    flex-direction: column;

    .lia-filter-options-widget {
      height: 70px;
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 10px;

      .row {
        width: 100%;

        .lia-search-input {
          width: 80%;
          margin-right: 10px;
        }
      }
    }

    .lia-list-container {
      height: calc(100% - 70px);
      overflow-y: auto;

      .internship-item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        border-radius: 10px;

        &:hover {
          background-color: #1ba5a541;
        }

        .internship-item-header {
          display: flex;
          justify-content: space-between;
          padding: 10px 20px;

          .internship-item-header-left {
            width: 70%;

            .internship-item-title-widget {
              display: flex;
              align-items: center;
              width: 100%;

              .internship-item-title {
                font-size: 19px;
                font-weight: 500;
                color: #18181b;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0px;
              }

              .internship-item-worktype {
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: #f0fdfa;
                border-radius: 20px;
                padding: 4px 10px;

                span {
                  color: #0884af;
                }
              }
            }

            .internship-item-location {
              font-size: 12px;
              color: #a1a1aa;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0px;
            }

            .internship-item-date {
              font-size: 12px;
              color: #a1a1aa;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0px;
            }
          }

          .internship-item-header-right {
            .internship-item-selected-widget {
              display: flex;
              align-items: center;
              color: #0884af;
            }
          }
        }

        .internship-item-body {
          padding: 10px 20px;

          .internship-item-tags {
            display: flex;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>